export default class {
  // 按下确定
  confirm() {
    this.$emit('confirm');
  }
}
